import React from 'react';
import { Col, Row } from 'reactstrap';
import { InputFormField } from '../../../../../components/InputFormField';
import classNames from 'classnames';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { DeactivateUserFormValues } from '..';

interface PropTypes {
  register: UseFormRegister<DeactivateUserFormValues>;
  errors: FieldErrors;
}

export function ConfirmationRow(props: PropTypes) {
  return (
    <Row className='mb-3'>
      <Col sm={12}>
        <InputFormField
          type={'text'}
          registerReturn={props.register('confirmation', {
            required: true,
            validate: (value) => value === 'CONFIRM',
          })}
          fieldName={'Please type "CONFIRM" below to proceed:'}
          classNames={classNames(
            props.errors.confirmation && 'is-invalid',
            'fs-5',
          )}
        />
      </Col>
    </Row>
  );
}
